import {
    GdAdditionalTargetingJoinType,
    GdAdditionalTargetingJoinTypeInput,
    GdAdditionalTargetingMode,
    GdAdditionalTargetingModeInput,
    GdAdditionalTargetingUatraitsInput,
    InterfaceLang
} from './graphql-grid';
import { EditInternalGroupDataValue } from './groupsEditState';

export interface TargetingYandexUids {
    targetingMode: GdAdditionalTargetingMode;
    joinType: GdAdditionalTargetingJoinType;
    value: string;
}

export interface TargetingInternalNetwork {
    targetingMode: GdAdditionalTargetingMode;
    joinType: GdAdditionalTargetingJoinType;
    uncheckAll?: boolean;
}

export interface TargetingIsTablet {
    targetingMode: GdAdditionalTargetingMode;
    joinType: GdAdditionalTargetingJoinType;
    uncheckAll?: boolean;
}

export interface TargetingIsMobile {
    targetingMode: GdAdditionalTargetingMode;
    joinType: GdAdditionalTargetingJoinType;
    uncheckAll?: boolean;
}

export interface TargetingIsTouch {
    targetingMode: GdAdditionalTargetingMode;
    joinType: GdAdditionalTargetingJoinType;
    uncheckAll?: boolean;
}

export interface TargetingIsBrowser {
    targetingMode: GdAdditionalTargetingMode;
    joinType: GdAdditionalTargetingJoinType;
    uncheckAll?: boolean;
}

export interface TargetingOsNames {
    targetingMode: GdAdditionalTargetingMode;
    joinType: GdAdditionalTargetingJoinType;
    value: GdAdditionalTargetingUatraitsInput[];
}

export interface TargetingOsFamilies {
    targetingMode: GdAdditionalTargetingMode;
    joinType: GdAdditionalTargetingJoinType;
    value: GdAdditionalTargetingUatraitsInput[];
}

export interface TargetingBrowserNames {
    targetingMode: GdAdditionalTargetingMode;
    joinType: GdAdditionalTargetingJoinType;
    value: GdAdditionalTargetingUatraitsInput[];
}

export interface TargetingBrowserEngines {
    targetingMode: GdAdditionalTargetingMode;
    joinType: GdAdditionalTargetingJoinType;
    value: GdAdditionalTargetingUatraitsInput[];
}

export interface TargetingDeviceNames {
    targetingMode: GdAdditionalTargetingMode;
    joinType: GdAdditionalTargetingJoinType;
    value: string;
}

export interface TargetingDeviceVendors {
    targetingMode: GdAdditionalTargetingMode;
    joinType: GdAdditionalTargetingJoinType;
    value: GdAdditionalTargetingUatraitsInput[];
}

export interface TargetingQueryReferers {
    targetingMode: GdAdditionalTargetingMode;
    joinType: GdAdditionalTargetingJoinType;
    value: string;
}

export interface TargetingInterfaceLangs {
    targetingMode: GdAdditionalTargetingMode;
    joinType: GdAdditionalTargetingJoinType;
    value: InterfaceLang[];
}

export interface TargetingUserAgents {
    targetingMode: GdAdditionalTargetingMode;
    joinType: GdAdditionalTargetingJoinType;
    value: string;
}

export interface TargetingShowDates {
    targetingMode: GdAdditionalTargetingMode;
    joinType: GdAdditionalTargetingJoinType;
    value: GraphQlLocalDate[];
}

export interface ApiFormatTargetingShowDates {
    targetingMode: GdAdditionalTargetingModeInput;
    joinType: GdAdditionalTargetingJoinTypeInput;
    value: GraphQlLocalDate[];
}

export enum AdditionalTargetingKey {
    YANDEX_UIDS = 'targetingYandexUids',
    OS_NAMES = 'targetingOsNames',
    OS_FAMILIES = 'targetingOsFamilies',
    BROWSER_NAMES = 'targetingBrowserNames',
    BROWSER_ENGINES = 'targetingBrowserEngines',
    DEVICE_NAMES = 'targetingDeviceNames',
    DEVICE_VENDORS = 'targetingDeviceVendors',
    USER_AGENTS = 'targetingUserAgents',
    QUERY_REFERERS = 'targetingQueryReferers',
    INTERFACE_LANGS = 'targetingInterfaceLangs',
    INTERNAL_NETWORK = 'targetingInternalNetwork',
    IS_BROWSER = 'targetingIsBrowser',
    IS_MOBILE = 'targetingIsMobile',
    IS_TABLET = 'targetingIsTablet',
    IS_TOUCH = 'targetingIsTouch',
    SHOW_DATES = 'targetingShowDates'
}

export type TernaryControlExternalValueKey =
    | AdditionalTargetingKey.INTERNAL_NETWORK
    | AdditionalTargetingKey.IS_BROWSER
    | AdditionalTargetingKey.IS_MOBILE
    | AdditionalTargetingKey.IS_TABLET
    | AdditionalTargetingKey.IS_TOUCH;

export type BinaryControlExternalValueKey =
    | AdditionalTargetingKey.YANDEX_UIDS
    | AdditionalTargetingKey.OS_NAMES
    | AdditionalTargetingKey.OS_FAMILIES
    | AdditionalTargetingKey.BROWSER_NAMES
    | AdditionalTargetingKey.BROWSER_ENGINES
    | AdditionalTargetingKey.DEVICE_NAMES
    | AdditionalTargetingKey.DEVICE_VENDORS
    | AdditionalTargetingKey.USER_AGENTS
    | AdditionalTargetingKey.QUERY_REFERERS
    | AdditionalTargetingKey.INTERFACE_LANGS;

export type TernaryControlExternalValue = Required<
    EditInternalGroupDataValue
>[TernaryControlExternalValueKey];

export type BinaryControlExternalValue = Required<
    EditInternalGroupDataValue
>[BinaryControlExternalValueKey];

export type StringDictExternalValueKey =
    | AdditionalTargetingKey.OS_NAMES
    | AdditionalTargetingKey.OS_FAMILIES
    | AdditionalTargetingKey.BROWSER_NAMES
    | AdditionalTargetingKey.BROWSER_ENGINES
    | AdditionalTargetingKey.DEVICE_VENDORS;

export type InputExternalValueKey =
    | AdditionalTargetingKey.YANDEX_UIDS
    | AdditionalTargetingKey.DEVICE_NAMES
    | AdditionalTargetingKey.USER_AGENTS
    | AdditionalTargetingKey.QUERY_REFERERS;

export type StringDictExternalValue = Required<
    EditInternalGroupDataValue
>[StringDictExternalValueKey];

export type InputExternalValue = Required<
    EditInternalGroupDataValue
>[InputExternalValueKey];

export type InternalGroupFieldValue =
    | BinaryControlExternalValue
    | TernaryControlExternalValue;

export enum TernaryControlOwnValue {
    YES = 'yes',
    NO = 'no',
    NOT_SELECTED = 'not-selected'
}

export enum BinaryControlOwnValue {
    INCLUDED = 'included',
    EXCLUDED = 'excluded'
}

export interface InternalGroupTargetingValueItem {
    id: string;
    name: string;
}
